<!--
    描述：模板设置 --- 首页
    时间：2020-11-21
    Created by ws
-->
<template>
	<div class="h100">
	  <filter-layout @search="doSearch" @reset="doRefresh">
		<template #filter>
		  <el-form
			class="flex-row-form colspan-4"
			size="small"
			ref="searchForm"
			label-width="100px"
			:model="searchForm"
		  >
			<el-form-item label="模板名称：">
			  <el-input v-model="searchForm.sname" size="small"></el-input>
			</el-form-item>
			<el-form-item label="模板应用：">
			  <el-select v-model="searchForm.applySys" size="small">
				<el-option
				  v-for="(item, index) in ywxt"
				  :key="'系统' + index"
				  :value="item.value"
				  :label="item.sname"
				></el-option>
			  </el-select>
			</el-form-item>
			<el-form-item label="模板类型：" size="small">
			  <el-select v-model="searchForm.protpcolType" size="small">
				<el-option
				  v-for="(item, index) in typeList"
				  :key="'类型' + index"
				  :value="item.value"
				  :label="item.sname"
				></el-option>
			  </el-select>
			</el-form-item>
		  </el-form>
		</template>
		<template #content>
		  <div class="content-header">
			<div class="title"></div>
			<div class="btnGroups">
			  <el-button
				size="small"
				class="btn-blue pdl20"
				icon="el-icon-plus"
				@click="addTemplate"
				v-if="roleBtns.includes('templateAdd')"
				>新增协议模板</el-button
			  >
			</div>
		  </div>
		  <!-- 表格内容 -->
		  <div class="w-table-layout w-table-page">
			<div class="w-table-content">
			  <vxe-table
				:data="tableData"
				border
				resizable
				size="small"
				highlight-current-row
				highlight-hover-row
				show-overflow="tooltip"
				show-header-overflow="tooltip"
				height="100%"
				:loading="loading"
			  >
				<vxe-table-column
				  type="seq"
				  title="序号"
				  width="60"
				  align="center"
				></vxe-table-column>
				<vxe-table-column
				  field="sname"
				  title="模板名称"
				  show-overflow
				  min-width="180"
				  header-align="center"
				></vxe-table-column>
				<vxe-table-column
				  field="applySysName"
				  title="模板应用"
				  min-width="150"
				  align="center"
				></vxe-table-column>
				<vxe-table-column
				  field="protpcolTypeName"
				  title="模板类型"
				  show-overflow
				  min-width="150"
				  align="center"
				></vxe-table-column>
				<vxe-table-column
				  field="createUseridName"
				  title="创建人"
				  min-width="150"
				  align="center"
				></vxe-table-column>
				<vxe-table-column
				  field="createDate"
				  title="创建时间"
				  min-width="150"
				  align="center"
				></vxe-table-column>
				<vxe-table-column title="状态" width="100" align="center">
				  <template v-slot="{ row }">
					<vxe-switch
					  v-model="row.status"
					  open-label="启用"
					  close-label="禁用"
					  :open-value="1"
					  :close-value="0"
					  @change="handleSwitch(row.id, $event)"
					  v-if="roleBtns.includes('templateCheck')"
					></vxe-switch>
				  </template>
				</vxe-table-column>
				<vxe-table-column title="操作" width="170" align="center">
				  <template v-slot="{ row }">
					<el-button
					  type="success"
					  size="small"
					  round
					  plain
					  class="table-btn"
					  :disabled="row.status === 1"
					  @click="doEdit(row)"
					  v-if="roleBtns.includes('templateEdit')"
					>
					  <svg-icon icon-class="form-edit"></svg-icon> 编辑
					</el-button>
					<!-- <span class="btn-separator"> | </span> -->
					<el-button
					  type="danger"
					  size="samll"
					  class="table-btn"
					  round
					  plain
					  icon="el-icon-delete"
					  :disabled="row.status === 1"
					  @click="doDelete(row.id)"
					  v-if="roleBtns.includes('templateDelete')"
					  >删除</el-button
					>
				  </template>
				</vxe-table-column>
			  </vxe-table>
			</div>
			<div class="w-table-footer">
			  <vxe-pager
				size="mini"
				:current-page="currentPage"
				:page-size="pageSize"
				:total="totalResult"
				class="text-center"
				:page-sizes="[10, 20, 50, 100, { label: '全部数据', value: -1 }]"
				:layouts="[
				  'Total',
				  'Sizes',
				  'PrevPage',
				  'JumpNumber',
				  'NextPage',
				]"
				@page-change="handlePageChange"
			  >
			  </vxe-pager>
			</div>
		  </div>
		</template>
	  </filter-layout>
	  <!-- 新增协议模板弹窗 -->
	  <el-dialog
		:visible.sync="dialogObj.visible"
		:width="dialogObj.width"
		:title="dialogObj.title"
		top="10vh"
		center
		:close-on-click-modal="false"
	  >
		<add-template
		  ref="addTemplate"
		  v-if="dialogObj.visible"
		  @on-save="onSave"
		  :mode="dialogObj.mode"
		  :currentRow="currentRow"
		></add-template>

		<!-- footer 组件 -->
		<div slot="footer" class="dialog-footer text-center">
		  <el-button size="small" class="btn" @click="dialogObj.visible = false"
			>取 消</el-button
		  >
		  <el-button
			type="primary"
			size="small"
			class="btn btn-blue"
			:loading="dialogObj.btnLoading"
			@click="doSave"
			>确 定</el-button
		  >
		</div>
	  </el-dialog>
	</div>
  </template>

<script>
import { getDictByParentValue } from "api/modules/dict";
import {
	delTemplate,
	getTemplates,
	setStatus,
} from "api/modules/field_management";
import { mapState } from "vuex";

import addTemplate from "./add_template";

export default {
	components: {
		addTemplate,
	},
	data() {
		return {
			searchForm: {
				sname: '',
				applySys: '',
				protpcolType: '',
			},
			typeList: [], // 应用类型数组
			tableData: [],
			currentPage: 1,
			pageSize: 10,
			totalResult: 0,
			loading: false,
			dialogObj: {
				visible: false,
				title: '新增协议模板',
				width: '1200px',
				mode: 'add',
				btnLoading: false,
			},
			currentRow: {},
		}
	},
	created() {
		this.doSearch()
	},
	methods: {
		// 查询获得规则
		doSearch() {
			this.tableData = []
			this.loading = true
			let params = {
				sname: this.searchForm.sname,
				applySys: this.searchForm.applySys,
				protpcolType: this.searchForm.protpcolType,
				current: this.currentPage,
				size: this.pageSize,
			}
			getTemplates(params)
				.then((res) => {
					this.loading = false
					// console.log(res)
					if (res.code === 0) {
						this.totalResult = parseInt(res.data.total)
						this.tableData = res.data.records
					}
				})
				.catch((err) => {
					this.loading = false
				})
		},

		// 点击切换启用状态
		handleSwitch(id, { value }) {
			let _flag = value ? 1 : 0
			let msg = value ? '已启用' : '已禁用'
			setStatus({ id: id, status: _flag })
				.then((res) => {
					if (res.code === 0) {
						this.$message.success(msg)
					}
				})
				.catch((err) => {})
		},

		// 切换页码
		handlePageChange({ currentPage, pageSize }) {
			this.currentPage = currentPage
			this.pageSize = pageSize

			this.doSearch()
		},

		// 切换业务系统
		handleChange(value) {
			this.searchForm.protpcolType = ''
			this.typeList = []

			if (value) {
				getDictByParentValue({ value: value }).then((res) => {
					if (res.operationCode === 1) {
						this.typeList = res.data
					}
				})
			}
		},

		// 点击刷新
		doRefresh() {
			this.searchForm.sname = ''
			this.searchForm.applySys = ''
			this.searchForm.protpcolType = ''

			this.doSearch()
		},

		// 点击新增协议模板
		addTemplate() {
			this.dialogObj.visible = true
			this.dialogObj.title = '新增协议模板'
			this.dialogObj.mode = 'add'
		},

		// 点击编辑
		doEdit(row) {
			this.currentRow = Object.assign({}, row)

			this.dialogObj.visible = true
			this.dialogObj.title = '编辑协议模板'
			this.dialogObj.mode = 'edit'
		},

		// 点击删除
		doDelete(id) {
			this.$confirm('确认删除该协议模板吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					delTemplate({ id: id })
						.then((res) => {
							this.$message.success('删除成功！')
							this.doRefresh()
						})
						.catch((err) => {})
				})
				.catch(() => {})
		},

		// 点击保存模板
		doSave() {
			this.dialogObj.btnLoading = true
			this.$refs.addTemplate.doSubmit()
		},

		// 保存回调
		onSave(status) {
			if (status) {
				this.dialogObj.visible = false
				this.dialogObj.btnLoading = false

				this.doSearch()
			} else {
				setTimeout(() => {
					this.dialogObj.btnLoading = false
				}, 2000)
			}
		},
	},
	computed: {
		...mapState('dict', {
			ywxt: (state) => state.projectDict.mbywxt, // 业务系统
		}),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
	},
	watch: {
		// 监听业务系统变化
		'searchForm.applySys': {
			handler: function (val) {
				this.handleChange(val)
			},
			deep: true,
		},
	},
}
</script>

<style scoped lang="less">
.ml25 {
	margin-left: 25px;
}
.content-header{
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px 0;
	.title {
	  padding-left: 10px;
	  border-left: 4px solid #2671cc;
	  font-size: 14px;
	  color: #202020;
	}
	.blue{
	  font-size: 18px;
	  color: #2671cc;
	}
  }
</style>

<style scoped>
 .el-dialog__body {
	height: 70vh;
	max-height: unset;
	overflow: hidden;
}
</style>
